module.exports = __webpack_public_path__ + "static/media/logo-fix-play.ce06d010.svg";